import {Color} from 'three'

import type {DitherParams} from '../../components/WebGLContext/WebGLContext.types'
import shaderLinearGradientFrag from '../_shaders/dithering/linearGradient.frag'
import shaderNoiseGradientFrag from '../_shaders/dithering/noiseGradient.frag'
import type {DitheringBackgroundType, DitheringVariant} from './DitheringEffect.types'

export const VARIANTS: Record<DitherParams['color'], DitheringVariant> = {
  security: {
    backgroundType: 'linearGradient',
    uniforms: {
      uColor0: {value: new Color(0x0037ff)},
      uColor1: {value: new Color(0xffffff)},
      uDotColor: {value: new Color(0xc7e2ff)},
    },
  },
  copilot: {
    backgroundType: 'linearGradient',
    uniforms: {
      uColor0: {value: new Color(0x8b33fd)},
      uColor1: {value: new Color(0xffffff)},
      uDotColor: {value: new Color(0xb983fe)},
    },
  },
  pearl: {
    backgroundType: 'noiseGradient',
    uniforms: {
      uColor0: {value: new Color(0xbecdf8)},
      uColor1: {value: new Color(0xccefda)},
      uColor2: {value: new Color(0xfcf0d7)},
      uColor3: {value: new Color(0xf0d7eb)},
      uDotColor: {value: new Color(0xf3e1fe)},
      uColor0Weight: {value: 2.6},
      uColor1Weight: {value: 1.9},
      uColor2Weight: {value: 0.3},
      uColor3Weight: {value: 0.9},
      uRegionScale: {value: 0.2},
      uDetailScale: {value: 0.4},
      uDetailAmount: {value: 0.85},
      uWarpAmount: {value: 1.5},
      uSoftness: {value: 0.88},
      uXOffset: {value: 1.72},
      uYOffset: {value: -4.71},
    },
    backgroundVisibilityThreshold: 0.3,
  },
  default: {
    backgroundType: 'linearGradient',
    uniforms: {
      uColor0: {value: new Color(0x08872b)},
      uColor1: {value: new Color(0xffffff)},
      uDotColor: {value: new Color(0xc0ffd1)},
    },
  },
}

export const BACKGROUND_FRAGMENT_SHADERS: Record<DitheringBackgroundType, string> = {
  linearGradient: shaderLinearGradientFrag,
  noiseGradient: shaderNoiseGradientFrag,
}
